import { Button, FilterCommon, PageHeader, Table } from "@/components";
import {
  downloadFile,
  filtersJson,
  getMessageResponseType,
  handleMessagesAPI,
  PAGINATION_DEFAULT,
  reportPolicyMappingColumns,
  REPORT_POLICY_MAPPING_SCREEN,
  ROUTER_PAGE_REPORT,
} from "@/utils";
import { mapState } from "vuex";

const dataSources = [
  {
    id: 1,
    staff: "Vũ Thị Thu Thúy - TDX Dept (vttthuy1)",
    workScheduleCode: "GLB_FLEX_8H00_9H30_6 HOURS",
    workScheduleType: "Flexible",
    time: "08:30 - 17:30",
    workingTime: "8.00 hour(s)",
    explanationRule: "03 times/ payroll period, 02 hours/ time, 01 time/ day",
    dateApplied: "01/06/2022",
    dateExpired: "01/06/2022",
  },
  {
    id: 2,
    staff: "Kiều Hồng Thanh - DU 11 (khthanh)",
    workScheduleCode: "GLB_FLEX_8H00_9H30_6 HOURS",
    workScheduleType: "Flexible",
    time: "08:30 - 17:30",
    workingTime: "8.00 hour(s)",
    explanationRule: "03 times/ payroll period, 02 hours/ time, 01 time/ day",
    dateApplied: "01/06/2022",
    dateExpired: "01/06/2022",
  },
];
export default {
  name: "ReportMapping",
  components: {
    Table,
    FilterCommon,
    PageHeader,
    Button,
  },
  data() {
    return {
      dataFilterDefault: {},
      filterList: filtersJson[REPORT_POLICY_MAPPING_SCREEN],
      columns: reportPolicyMappingColumns,
      REPORT_POLICY_MAPPING_SCREEN,
      dataSources,
      filter: PAGINATION_DEFAULT,
    };
  },
  watch: {
    filter() {
      this.getReportMapping();
    },
  },
  computed: {
    ...mapState({
      reportWorkScheduleList: (state) => state.report.reportWorkScheduleList,
      pages: (state) => state.report.pages,
    }),
    checkShowAction() {
      return true;
    },
  },
  mounted() {
    this.getReportMapping();
  },
  methods: {
    onBack() {
      this.$router.push({ name: ROUTER_PAGE_REPORT });
    },
    async getReportMapping() {
      this.$store.dispatch("user/loadingRequest");
      try {
        await this.$store.dispatch("report/getReportWorkScheduleList", this.filter);
      } catch (error) {
        handleMessagesAPI(error.response.data);
      } finally {
        this.$store.commit("user/RESET_LOADING");
      }
    },
    handleFilter(payload) {
      const { applyFromDate, applyToDate, expireFromDate, expireToDate } = payload;
      !applyFromDate && delete this.filter?.applyFromDate;
      !applyToDate && delete this.filter?.applyToDate;
      !expireFromDate && delete this.filter?.expireFromDate;
      !expireToDate && delete this.filter?.expireToDate;
      this.filter = { ...this.filter, ...payload, page: 1 };
    },
    async handleExportReport() {
      this.$store.dispatch("user/loadingRequest");
      try {
        const result = await this.$store.dispatch("report/exportReportWorkSchedule", this.filter);
        console.log("🚀 ~ file: index.js:99 ~ handleExportReport ~ result", result);
        const { data, headers } = result;
        const { code, message, filename } = headers;
        if (code == 200) {
          this.$toast.success(message);
          downloadFile(data, filename ?? "File.xlsx", headers["content-type"]);
        }
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        this.$store.commit("user/RESET_LOADING");
      }
    },
    handleChangePagination(payload) {
      this.filter = { ...this.filter, ...payload };
    },
  },
};
